import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

export default function ForbiddenPage() {
  return (
    <div className="min-h-screen bg-[#F6F2EB] text-[#37332F] flex flex-col justify-between p-6 md:p-12 relative overflow-hidden paper-grain">
      {/* Background Subtle Warmth */}
      <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(201,152,80,0.06)_0%,transparent_70%)] pointer-events-none" />

      {/* Header */}
      <header className="relative z-10">
        <Link to="/" className="inline-block" aria-label="Destilleriet Als forside">
          <img
            src="https://assets.auxodev.dk/cdn-cgi/image/width=320,quality=90,format=auto/assets/c8fc1da7-d576-4041-8666-592c544bae24/destilleriet-als-logo-mini_b0fc93ac.png"
            alt="Destilleriet Als"
            className="h-10 w-auto object-contain hover:opacity-85 transition-opacity"
          />
        </Link>
      </header>

      {/* Center Content */}
      <main className="relative z-10 max-w-2xl mx-auto text-center space-y-6 my-auto">
        <span className="text-xs font-['Montserrat'] text-[#C99850] uppercase tracking-[0.3em] font-medium">
          Fejl 403 · Adgang Forbudt
        </span>
        <h1 className="font-['Cormorant_Garamond'] text-5xl sm:text-6xl md:text-7xl font-light uppercase tracking-[0.2em] text-[#37332F]">
          Lukket Område
        </h1>
        <p className="text-sm md:text-base text-[#5E5852] font-light leading-relaxed max-w-lg mx-auto">
          Du har ikke rettigheder til at tilgå denne del af sitet. Vend tilbage til vores offentlige univers på forsiden.
        </p>

        <div className="pt-6">
          <Link
            to="/"
            className="inline-flex items-center gap-3 px-8 py-3.5 text-xs font-['Montserrat'] font-medium uppercase tracking-[0.25em] text-[#F6F2EB] bg-[#37332F] hover:bg-[#2B2724] transition-colors"
          >
            <ArrowLeft className="w-3.5 h-3.5" aria-hidden="true" />
            <span>Gå til forsiden</span>
          </Link>
        </div>
      </main>

      {/* Footer */}
      <footer className="relative z-10 text-center font-['Montserrat'] text-xs text-[#8E867E] uppercase tracking-widest">
        KALAS Distillery · Holtvej 8, 6470 Sydals
      </footer>
    </div>
  );
}
